import { Box } from "@mui/material";
import * as React from "react";
import { ReactComponent as ExclamationMarkSvg } from "../../../images/icons/ExclamationMark.svg";
import Texts from "../../../resources/Texts";

type FailedLoginDialogContentProps = { errorMessage?: string };

const FailedLoginDialogContent: React.FC<FailedLoginDialogContentProps> = ({ errorMessage }) => {
	return (
		<Box display="flex" flexDirection="row">
			<Box width="20px" marginRight="1em">
				<ExclamationMarkSvg />
			</Box>

			<Box width="428px">
				{errorMessage ?
					<Box>{errorMessage}</Box>
					:
					<Box>{Texts.Dialogs.FailedLoginDialog.Content1}</Box>
				}
			</Box>
		</Box>
	);
};

export default FailedLoginDialogContent;
